$(document).on('click', '.js-show-filter', () => {
  $('.js-filter').addClass('is-open')
  $('body').addClass('overflow-hidden')
})

$(document).on('click', '.js-hide-filter', () => {
  $('.js-filter').removeClass('is-open')
  $('body').removeClass('overflow-hidden')
})
